import { isValidElement, cloneElement, Children, useContext } from "react";
import AccordionContext from "@components/Accordion/accordionContext";

const AccordionItem = ({ id, children, isPreRendered = true }) => {
  const { onItemToggle, isItemToggleable, isItemExpanded } =
    useContext(AccordionContext);
  const handleToggle = (event) => onItemToggle(id, event);
  const isExpanded = isItemExpanded(id);
  const isToggleable = isItemToggleable(id);

  return (
    <div id={id}>
      {Children.map(children, (child) =>
        isValidElement(child)
          ? cloneElement(child, {
              id,
              isPreRendered,
              isExpanded,
              isToggleable,
              onToggle: handleToggle,
            })
          : child
      )}
    </div>
  );
};

export default AccordionItem;
